import { Route } from "react-router-dom";
import { ValkyraeScreen } from "./ValkyraeScreen";

export const routes = <Route path="valkyrae" Component={ValkyraeScreen} />;
